export const organizationKeys = {
  organizationAccess: () => ['ORGANIZATION_ACCESS'] as const,
  organizationRegions: (organizationId: number | string | undefined) =>
    ['ORGANIZATION_REGIONS', organizationId] as const,
  list: () => ['ORGANIZATION_LIST'] as const,
  single: (organizationId: number | string) =>
    ['ORGANIZATION', organizationId] as const,
};
